import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fd3527a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1fd3527a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3527a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd3527a')) {
      api.createRecord('1fd3527a', component.options)
    } else {
      api.reload('1fd3527a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fd3527a&scoped=true&", function () {
      api.rerender('1fd3527a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppHeader/index.vue"
export default component.exports